function group(array, by) {
    var groups = [];
    for (var i = 0, j = 0; i < array.length; i++) {
        if (i >= by && i % by === 0)
            j++;
        groups[j] = groups[j] || [];
        groups[j].push(array[i])
    }
    return groups;
}

export default group;